import { ProjectIntro } from "shared/projects/project-shared/project-intro";
import { ProjectDesc } from "shared/projects/project-shared/project-desc";
import { ProjectOutro } from "shared/projects/project-shared/project-outro";
import { SectionData } from "shared/types";

import { ProjectImage } from "shared/projects/project-shared/project-image";
import { ProjectMobile } from "shared/projects/project-shared/project-mobile";

export const Bubble = (props: SectionData) => {
  const projectImageData = {
    image: "bubbleDesktop" as const,
    text: "",
  };
  const projectMobileData = {
    mobile: "bubbleTablet" as const,
    tablet: "bubbleMobile" as const,
  };

  return (
    <div className="project color-white" style={{ backgroundColor: props.bg }}>
      <ProjectIntro {...props} />

      <div className="container full m-auto">
        <ProjectDesc {...props} />
        <ProjectImage {...projectImageData} />
        <ProjectMobile {...projectMobileData} />
      </div>

      <ProjectOutro {...props} />
    </div>
  );
};
